<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100 md-size-100">
      <h4>{{ this.title }}</h4>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-50">
      <md-field>
        <label>Bezeichnung des Lieferorts</label>
        <md-input v-model="firstname" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-50">
      <md-field>
        <label>Straße und Hausnummer</label>
        <md-input v-model="country" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-33">
      <md-field>
        <label htmlFor="shippingCountry">Unternehmensland</label>
        <md-select v-model="shippingCountry" name="shippingCountry" id="shippingCountry">
          <md-option value="germany">Deutschland</md-option>
          <md-option value="suiss">Schweiz</md-option>
          <md-option value="luxembourg">Luxembourg</md-option>
          <md-option value="austria">Österreich</md-option>
        </md-select>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-33">
      <md-field>
        <label>Postleitzahl</label>
        <md-input v-model="code" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-33">
      <md-field>
        <label>Ort</label>
        <md-input v-model="code" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-100">
      <h4>Lagerorte an dieser Lieferadresse</h4>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-33">
      <md-field>
        <label>Bezeichnung des Lagerorts</label>
        <md-input v-model="code" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-15">
      <md-button class="md-primary">
        <md-icon>add</md-icon>
      </md-button>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-45">
      <md-table md-card>
        <md-table-row>
          <md-table-head>Lagerorte</md-table-head>
        </md-table-row>
        <md-table-row>
          <md-table-cell>Lagerort 1</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>Lagerort 2</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-100">
      <md-field>
        <label>Anmerkungen für Lieferanten</label>
        <md-textarea v-model="textarea" md-autogrow></md-textarea>
      </md-field>
    </div>
    <md-divider class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 40px; margin-bottom: 40px;"></md-divider>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style>

</style>
